import { render, staticRenderFns } from "./SMSCampaignListCreateOrEdit.vue?vue&type=template&id=5f908651&"
import script from "./SMSCampaignListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignListCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignListCreateOrEdit.vue?vue&type=style&index=0&id=5f908651&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports